/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum Status {
  OFF = "OFF",
  ON = "ON",
  PENDING_OFF = "PENDING_OFF",
  PENDING_ON = "PENDING_ON",
}


export enum Platform {
  DARWIN = "DARWIN",
  DOCKER = "DOCKER",
  LINUX = "LINUX",
  UNKNOWN = "UNKNOWN",
  WIN32 = "WIN32",
}


export enum _ModelMutationType {
  CREATED = "CREATED",
  DELETED = "DELETED",
  UPDATED = "UPDATED",
}


export interface AllHostiesQuery {
  allHosties:  Array< {
    __typename: "Hostie",
    id: string,
    token: string,
    name: string | null,
    note: string | null,
    status: Status,
    platform: Platform,
    owner:  {
      __typename: "User",
      email: string,
      id: string,
      name: string | null,
    },
  } >,
};

export interface SubscribeHostieSubscription {
  Hostie:  {
    __typename: "HostieSubscriptionPayload",
    mutation: _ModelMutationType,
    node:  {
      __typename: "Hostie",
      id: string,
      token: string,
      name: string | null,
      note: string | null,
      status: Status,
      platform: Platform,
      owner:  {
        __typename: "User",
        email: string,
        id: string,
        name: string | null,
      },
    } | null,
    previousValues:  {
      __typename: "HostiePreviousValues",
      id: string,
      token: string,
    } | null,
  } | null,
};

export interface DeleteHostieMutationVariables {
  id: string,
};

export interface DeleteHostieMutation {
  deleteHostie:  {
    __typename: "Hostie",
    id: string,
  } | null,
};

export interface CreateHostieMutationVariables {
  token: string,
  name: string,
  ownerId: string,
};

export interface CreateHostieMutation {
  createHostie:  {
    __typename: "Hostie",
    id: string,
    token: string,
    name: string | null,
    note: string | null,
    status: Status,
    platform: Platform,
    owner:  {
      __typename: "User",
      email: string,
      id: string,
      name: string | null,
    },
  } | null,
};

export interface UpdateHostieMutationVariables {
  id: string,
  name?: string | null,
  note?: string | null,
};

export interface UpdateHostieMutation {
  updateHostie:  {
    __typename: "Hostie",
    id: string,
    token: string,
    name: string | null,
    note: string | null,
    status: Status,
    platform: Platform,
    owner:  {
      __typename: "User",
      email: string,
      id: string,
      name: string | null,
    },
  } | null,
};

export interface HostieFragment {
  __typename: "Hostie",
  id: string,
  token: string,
  name: string | null,
  note: string | null,
  status: Status,
  platform: Platform,
  owner:  {
    __typename: "User",
    email: string,
    id: string,
    name: string | null,
  },
};
